import request from '@/CommonDP/utils/request';
// 注册模块
export default {
  // 发送验证码
  smssendVerifyCode(data) {
    return request.post('/sms/sendVerifyCode', data).then((res) => res);
  },
  // 判断手机号是否注册且判断有没有名字 res.data 0未注册 1是已注册 有名字 2已注册 没有名字
  userexists(data) {
    // 返回数据是数字类型
    return request.post('/user/getPhoneStatus', data).then((res) => res);
  },
  // 注册
  userregister(data) {
    return request.post('/user/register', data).then((res) => res);
  },
  // 找回密码/重置密码
  userresetPassword(data) {
    return request.post('/user/resetPassword', data).then((res) => res);
  },
  // 创建企业
  enterprisecreate(data) {
    return request.post('/enterprise/create', data).then((res) => res);
  },
  // 判断企业全称是否注册
  enterprisegetByEnterpriseName(name) {
    return request
      .get(`/enterprise/getByEnterpriseName?name=${name}`)
      .then((res) => res);
  },
  // 企业详情
  getEnterpriseDetails(enterpriseId) {
    return request
      .get(
        '/enterprise/getEnterpriseDetails?enterpriseId=' + enterpriseId
      )
      .then((res) => res);
  },
  // 修改企业
  enterpriseupdate(data) {
    return request.post('/enterprise/update', data).then((res) => res);
  },
  userverifyName(data) {
    return request.post('/user/verifyName', data).then((res) => res);
  },
  enterprisegetEnterpriseDetails(enterpriseId) {
    return request
      .get(
        '/enterprise/getEnterpriseDetails?enterpriseId=' + enterpriseId
      )
      .then((res) => res);
  },
  usergetEnterpriseList() {
    return request.get(`/user/getEnterpriseList`).then((res) => res);
  },
  joinrefuse(data) {
    return request
      .post('/enterprise/join/refuse', data)
      .then((res) => res);
  },
  joinagree(data) {
    return request
      .post('/enterprise/join/agree', data)
      .then((res) => res);
  },
  updateEnterpriseDissolve(enterpriseId) {
    return request
      .get(
        `/enterprise/updateEnterpriseDissolve?enterpriseId=` +
          enterpriseId
      )
      .then((res) => res);
  },
  jointrial(data) {
    return request
      .post('/enterprise/join/trial', data)
      .then((res) => res);
  },
  smscheckVerifyCode(data) {
    return request.post('/sms/checkVerifyCode', data).then((res) => res);
  },
  getInviteJoinEnterpriseList() {
    return request
      .get(`/user/getInviteJoinEnterpriseList`)
      .then((res) => res);
  },
  projectJoin(inviteCode) {
    return request
      .get(`/project/join?inviteCode=` + inviteCode)
      .then((res) => res);
  },
  inviteverifyInviteCode(inviteCode) {
    return request
      .get(
        `/enterprise/invite/verifyInviteCode?inviteCode=` + inviteCode
      )
      .then((res) => res);
  },
  userGetUserByPhone(phone) {
    return request
      .get(
        `/user/getUserByPhone?phone=` + phone
      )
      .then((res) => res);
  }
};
